import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import './assets/css/font-awesome.css';
import SuperAdmin from "./components/SuperAdmin/Home/superAdminHome";
import reset from "./components/Auth/resetPassword";
import error404 from "./components/Misc/404";
import PaymentSetupError from "./components/Misc/paymentSetupError"
import forgotPassword from "./components/Auth/forgotPassword";
import Login from "./components/Auth/Login";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import SchoolAdmin from "./components/SchoolAdmin/Home/schoolAdminHome";
import ActivateParent from "./components/Parent/Home/activateParent";
import ParentDeviceRegister from './components/Parent/Home/parentDeviceRegister';
import ParentDashboard from './components/Parent/Home/parentHome';
import NotificationSystem from 'react-notification-system';
import './assets/css/style.css'
import {Provider} from "./server/context";
import $ from 'jquery';
import {getCookie} from "./server/util";
import PropTypes from "prop-types";
import setUpSchool from "./components/SchoolAdmin/SetUpSchool/setUpSchool";
import CatererHome from './components/Caterer/Home/CatererHome'
import DistrictHome from './components/District/Home/districtHome'
import PaymentSetup from './components/PaymentSetup/paymentSetup';
import PaypalPaymentSetup from './components/PaymentSetup/paypalPaymentSetup';
import FreeReducedProgram from './components/FreeReducedProgram';
import Footer from './components/Misc/AppFooter'
import reactga from 'react-ga';
import 'chartjs-plugin-datalabels';
import ParentOtherLogin from './components/ParentOtherLogin';
import StudentRegistration from './components/SchoolAdmin/Home/studentRegistration';
let checkCookie = checkCookie = (props, context) => {
    let cookieData = getCookie('parent');
    const cookieObj = cookieData == '' ? undefined : (JSON.parse(cookieData) || undefined);
    if (cookieObj == undefined) {
        sessionStorage.removeItem('bcacUrl')
        window.location.replace('/404')
        return false;
    }
    let token = cookieObj.token;
    let parentEmail = cookieObj.email;
    window.location.replace('/activateParentAccount?parentId=' + parentEmail + '&token=' + token)
}
const SchoolRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            (sessionStorage.getItem("access_token") && (sessionStorage.getItem("ROLE") === "ROLE_ADMIN")) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {from: props.location}
                    }}
                />
            )
        }
    />
);
const CatererRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            (sessionStorage.getItem("access_token") && (sessionStorage.getItem("ROLE") === "ROLE_CATERER")) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {from: props.location}
                    }}
                />
            )
        }
    />
);
const AdminRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            (sessionStorage.getItem("access_token") && (sessionStorage.getItem("ROLE") === "ROLE_SUPERADMIN")) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {from: props.location}
                    }}
                />
            )
        }
    />
);
const DistrictRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            (sessionStorage.getItem("access_token") && (sessionStorage.getItem("ROLE") === "ROLE_DISTRICT")) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {from: props.location}
                    }}
                />
            )
        }
    />
);

const ParentRoute = ({component: Component, ...rest}) => {
    const _props={...rest};
    if(((_props.location).pathname.split('/').includes('pkgDuePayment'))){
        sessionStorage.setItem('bcacUrl',((_props.location).pathname+(_props.location).search));
    }else{
        sessionStorage.removeItem('bcacUrl')
    }
    return(
    <Route
        {...rest}
        render={props =>

            ((sessionStorage.getItem("access_token")) && (sessionStorage.getItem("ROLE") === "ROLE_PARENT")) ? (
                <Component {...props} />
            ) : ((sessionStorage.getItem("access_token") === undefined) ?  (
                    <Redirect {...props} to={{
                        pathname: "/activateParentAccount",
                        state: {from: props.location}
                    }}/>
                ) : (checkCookie())
            )
        }
    />
)};


let devRespData = {};

//const history = createBrowserHistory();

class App extends Component {

    setUserInfo = (data) => {
        //todo: loop through data and add all req fields to another obj
        //info = {};
        //alert('came to app'+JSON.stringify(data,null,2));
        /* data.forEach(item =>{
             info.con
         })*/
        console.log('data of user', data);
        this.setState({loggedInUserInfo: data})

    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        reactga.initialize('UA-123981741-1')
        //to report page view
        reactga.pageview('/');
        (function () {
            var header_area = $('.header-wrapper');
            if (header_area.width() > 750) {
                $('.nav .dropdown').hover(function () {
                        $(this).addClass('open');
                    },
                    function () {
                        $(this).removeClass('open');
                    }
                );
            }
        })();
    }

    constructor() {
        super();
        this.state = {
            loggedInUserInfo: {}
        }

    }

    validateParent(resData) {
        devRespData = resData;
    }

    render() {
        console.log('data of user', this.state.loggedInUserInfo)
        return (<Fragment>
                <NotificationSystem ref="notificationSystem"/>
                <Provider value={this.state.loggedInUserInfo}>
                    
                        <Router>
                            <Switch>
                                <Route exact={true} path="/"
                                    render={(props) => <Login {...props} setUserInfo={this.setUserInfo}/>}/>
                                <Route exact={true} path="/login"
                                    render={(props) => <Login {...props} setUserInfo={this.setUserInfo}/>}/>
                                <Route exact={true} path="/privacy-policy"
                                    render={(props) => <PrivacyPolicy {...props} />}/>
                                <AdminRoute path="/superAdmin" component={SuperAdmin}/>
                                <SchoolRoute path="/schoolAdmin" component={SchoolAdmin}/>
                                <CatererRoute path="/caterer" component={CatererHome} />
                                <DistrictRoute path="/district" component={DistrictHome} />
                                <Route path="/activateParentAccount"
                                    render={() => <ActivateParent validateParent={this.validateParent}/>}/>
                                <ParentRoute path="/deviceRegister" component={ParentDeviceRegister}/>
                                <ParentRoute path="/parent" component={ParentDashboard}/>
                                <Route path="/reset" component={reset}/>
                                <Route path="/activate" component={reset}/>
                                <Route exact={true} path="/forgotPassword" component={forgotPassword}/>
                                <Route exact={true} path="/404" component={error404}/>
                                <Route exact={true} path="/paymentsetup" component={PaymentSetup}/>
                                <Route exact={true} path="/paypalsetup" component={PaypalPaymentSetup}/>
                                <Route exact={true} path="/paymentsetuperror" component={PaymentSetupError} />
                                <Route exact={true} path="/free_reduced_program/:id?/:type" component={FreeReducedProgram} />
                                <Route exact={true} path="/free_reduced_program" component={FreeReducedProgram} />
                                <Route exact={true} path="/studentRegistration" component={StudentRegistration} />
                                <Route exact={true} path="/:domain?/parent"
                                    render={(props) => <ParentOtherLogin {...props}/>} />
                                <Redirect to="/404"/>
                            </Switch>
                        </Router>
                         <Footer /> 
                </Provider>
            </Fragment>
        );
    };
}

App.contextTypes = {
    router: PropTypes.object.isRequired
}
checkCookie.contextTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    })
}
export default App



// WEBPACK FOOTER //
// ./src/App.js